import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
import { Icon } from '@lululemon/ecom-pattern-library-icon';
import { LinkGenerator } from '@lululemon/ecom-pattern-library-link-generator';
import styles from './index.module.scss.js';

var _excluded = ["block", "mobileBlock", "children", "className", "disabled", "href", "icon", "tag", "type", "variant", "onClick"];
var BUTTON_VARIANTS = ['filledImpact', 'filled', 'outline', 'transparent'];
var iconChildren = (children, icon) => {
  return /*#__PURE__*/React.createElement("div", {
    className: cs(styles.iconButtonContent)
  }, /*#__PURE__*/React.createElement(Icon, {
    className: cs(styles.iconButtonIcon),
    content: icon,
    "data-testid": "button-icon"
  }), /*#__PURE__*/React.createElement("span", null, children));
};
var Button = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
      block,
      mobileBlock,
      children,
      className,
      disabled,
      href,
      icon,
      tag,
      type,
      variant,
      onClick
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var Tag = tag || 'button';
  if (href && !tag) {
    Tag = LinkGenerator;
  }
  return /*#__PURE__*/React.createElement(Tag, _extends({
    className: cs(styles.button, 'lll-text-button', className, {
      [styles.buttonPrimary]: variant === 'filledImpact',
      [styles.buttonSecondary]: variant === 'filled',
      [styles.buttonTertiary]: variant === 'outline',
      [styles.buttonTransparent]: variant === 'transparent',
      [styles.buttonBlock]: block,
      [styles.buttonMobileBlock]: mobileBlock
    }),
    "aria-disabled": Tag === 'button' ? disabled : undefined,
    type: Tag === 'button' ? type : undefined,
    href: href,
    ref: ref,
    onClick: e => {
      if (disabled || !onClick) return;
      onClick(e);
    }
  }, otherProps), icon ? iconChildren(children, icon) : children);
});
var propTypes = {
  /** Whether to display as a block-level (full-width) button */
  block: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  /** Whether to add 'disabled' attribute - only supported when tag is 'button' */
  disabled: PropTypes.bool,
  /** When passed, will render a link styled to look like a button */
  href: PropTypes.string,
  /** An SVG node to be displayed at the left of the text */
  icon: PropTypes.node,
  /** Whether to display full-width only on mobile */
  mobileBlock: PropTypes.bool,
  /** The html tag for markup; defaults to <button> */
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  /** Value for the 'type' attribute - only supported when tag is 'button' */
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  /** Visual style of button */
  variant: PropTypes.oneOf(BUTTON_VARIANTS),
  /** Click handler if any */
  onClick: PropTypes.func
};
var defaultProps = {
  block: false,
  mobileBlock: false,
  className: null,
  disabled: false,
  href: null,
  icon: null,
  tag: null,
  type: 'button',
  variant: 'outline',
  onClick: undefined,
  children: null
};
Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

export { BUTTON_VARIANTS, Button, defaultProps, propTypes };
//# sourceMappingURL=index.js.map
